export default function createWrapperAndAppendToBody(wrapperId: string){
    const wrapperElement = document.createElement('div')
    wrapperElement.setAttribute("id", wrapperId)
    document.getElementById('root')!.appendChild(wrapperElement)
    return wrapperElement
}